<template>
  <div class="">

    <header>
      <div class="container">
        <div class="flex">
          <img src="../assets/img/phone.png">
          <span class="font14 margin-l-10 flex1 text-white">电话：{{phone}}</span>
          <template v-if="!token">
            <span class="font14 text-white" style="cursor: pointer;" @click="showLogin=true">登录</span>
            <span class="font14 line text-white">|</span>
            <span class="font14 text-white" style="cursor: pointer;" @click="showSignin=true">注册</span>
          </template>
          <template v-if="token">
            <span class="font14 text-white">欢迎你，{{accountInfo.nickName}}</span>
            <span class="font14 text-white" style="margin-left: 15px;cursor: pointer;"
              @click="handleMember()">个人中心</span>
            <span class="font14 line text-white">|</span>
            <span class="font14 text-white" style="cursor: pointer;" @click="handleSignout()">退出</span>
            <!--  <span style="margin-left: 15px;color: #9F6F42;font-size: 14px;">{{accountInfo.serviceExpire}}到期</span> -->
          </template>
          <span class="font14 line text-white">|</span>
          <span class="font14 text-white" style="cursor: pointer;" @click="handleNotice()">公告</span>
          <span class="font14 line text-white">|</span>
          <span class="font14 text-white" style="cursor: pointer;" @click="handleMessage()">消息</span>
        </div>
      </div>
    </header>
    <nav v-if="routerName.indexOf('homework?')==-1">
      <div class="container">
        <div class="flex" style="align-items: center;padding: 10px 0;">
          <div class="logo" style="font-size: 50px;cursor: pointer;" @click="handleToHome()">
            <img src="../assets/img/logo.png" style="width: 250px;">
          </div>
          <div class="flex1">

          </div>
          <div class="navlist" :class="{'active':routerName=='/'}" style="cursor: pointer;font-weight: bold;"
            @click="handleToHome()">
            首页
          </div>
          <div class="navlist" style="cursor: pointer;"
            :class="{'active':routerName=='/choose?id='+item.categoryId || routerName=='/courseDetail?id='+item.categoryId}"
            v-for="item in clist" @click="">
            <div class="navname" style="font-weight: bold;">{{item.categoryName}}</div>
            <ul class="childName">
              <div class="childName-bg"></div>
              <li v-for="voo in item.childCategoryList"
                @click="handleOnlineTest(item.categoryId,voo.categoryId,voo.categoryName)">{{voo.categoryName}}</li>
            </ul>
          </div>

        </div>
      </div>
    </nav>
    <template v-else>
      <div class="buy" v-if="1">
        <div class="container">
          <div class="flex" style="align-items: center;padding:15px 0;">
            <div class="logo" style="font-size: 50px;width: 250px;cursor: pointer;" @click="handleToHome()">
              培仕网校
            </div>
            <span style="font-size: 30px;">{{firstTitle}}</span>
            <span style="font-size: 20px;margin-left: 15px;color: #FC7424;">{{title}}</span>
            <!-- 	<span style="font-size: 18px;color: #ff854f;flex:1;margin-left: 20px;">试用中</span>
      			<span class="btnbuy" @click="handleBuy"> -->
            <!-- <img src="../assets/img/money.png" >
      				<span style="margin-left: 4px;color: #fff;">开通</span> -->
            </span>
            <!--      <span class="flex1"></span>
      			<span class="btnback">
      				<img src="../assets/img/back.png" width="16" >
      				<span style="margin-left: 4px;" @click="handleBack">返回</span>
      			</span> -->
          </div>
        </div>
      </div>
    </template>
    <template v-if="showLogin">
      <login @cancellogin="showLogin=false" @handleCodeLogin="handleCodeLogin" @handlesign="handlesign"
        @handleReset="handleReset()" @pwdLogined="pwdLogined"></login>
    </template>
    <template v-if="showSignin">
      <signin @handleOpenLogin="handleOpenLogin" @cancelsign="showSignin=false"
        @handleCloseSign="showSignin=false;getUserInfo()"></signin>
    </template>
    <template v-if="showCodeLogin">
      <codelogin @handlePwdLogin="handlePwdLogin" @codeLogined="codeLogined"
        @handleCloseCodeLogin="showCodeLogin=false"></codelogin>
    </template>
    <template v-if="showReset">
      <reset @reseted="showReset=false" @handleCloseReset="showReset=false"></reset>
    </template>
  </div>
</template>

<script>
  import login from './login.vue'
  import signin from './signin.vue'
  import codelogin from './codelogin.vue'
  import reset from './reset.vue'
  import bus from '../assets/utils/eventBus.js';
  export default {
    name: 'Footer',
    components: {
      login,
      signin,
      codelogin,
      reset
    },
    data() {
      return {
        showLogin: false,
        showSignin: false,
        showCodeLogin: false,
        phone: null,
        token: window.sessionStorage.token,
        showReset: false,
        accountInfo: {},
        clist: [],
        routerName: '',
        isshow: false,
        isShowWrap: true,
        categoryName: '',
        title: '',
        firstTitle: ''
      }
    },
    methods: {
      handleBuy() { //购买
        this.$router.push('buy')
      },
      handleBack() { //返回
        this.$router.go(-1);
      },
      handleOnlineTest(oneCategoryId, categoryId, categoryName) {
        if (!window.sessionStorage.token) {

          bus.$emit('login');
          return;

        }
        bus.$emit('checkBuy', {
          categoryId: categoryId,
          parentId: oneCategoryId,
          categoryName: categoryName
        });
        let data = new FormData();
        data.append('oneCategoryId', oneCategoryId);
        data.append('twoCategoryId', categoryId);
        window.sessionStorage.oneCategoryId = oneCategoryId;
        window.sessionStorage.twoCategoryId = categoryId;
        this.$axios.post(this.$common.login_accountCategory, data).then((res) => {
          console.log(res,'ressss')
          if (res.data.code == 1) {

            this.$router.push('homeworklist?d=' + new Date().getTime());
          } else {
            alert(res.data.msg)
          }
        })
      },
      handleChoose(id) {
        if (!window.sessionStorage.token) {

          bus.$emit('login');
          return;

        }
        this.$router.push({
          path: '/choose?id=' + id
        })
      },
      handleToHome() {
        this.$router.push('/')
      },
      pwdLogined() { //用户名密码登录成功
        console.log(456)
        this.showLogin = false;
        this.token = window.sessionStorage.token;
      },
      codeLogined() { //验证码登录成功
        this.showCodeLogin = false;
        this.token = window.sessionStorage.token;
      },
      handleReset() { //打开重置密码页面
        this.showLogin = false;
        this.showReset = true;
      },
      handlesign() { //关闭登录页面打开注册页面
        this.showLogin = false;
        this.showSignin = true;
      },
      handleOpenLogin() { //关闭注册页面打开登录页面
        this.showSignin = false;
        this.showLogin = true;
      },
      handleCodeLogin() { //关闭账号登录页面打开验证码登录页面
        console.log(55)
        this.showLogin = false;
        this.showCodeLogin = true;
      },
      handlePwdLogin() { // 打开登录页面关闭验证码登录界面
        console.log(5555)
        this.showLogin = true;
        this.showCodeLogin = false;
      },
      handleNotice() { // 系统通知
        if (!this.token) {

          this.showLogin = true;
          return;
        }
        this.$router.push({
          path: '/noticelist'
        })
      },
      handleMessage() { //消息页面
        if (!this.token) {

          this.showLogin = true;
          return;
        }
        this.$router.push({
          path: '/message'
        })
      },
      getCustomer() { //获取客服电话
        this.$axios.post(this.$common.customer_url).then((res) => {
          console.log(res,'resrese')
          if (res.data.code == 1) {
            this.phone = res.data.data;
          } else {
            alert(res.data.msg)
          }
        })
      },
      handleSignout() { //退出登录
        window.sessionStorage.token = '';
        this.token = ''

        this.$router.push('/')
      },
      handleMember() { //个人中心
        this.$router.push({
          path: '/noticelist'
        })
      },
      getUserInfo() { //获取跟人信息
        this.token = window.sessionStorage.token;
        if (!this.token) {
          return;
        }
        this.$axios.defaults.headers.common["Authorization"] = window.sessionStorage.token;
        this.$axios.post(this.$common.personal_detail).then((res) => {
          if (res.data.code == 1) {
            this.accountInfo = res.data.data;
          } else {
            alert(res.data.msg)
          }
        })
      },
      getList() {
        this.$axios.get(this.$common.categorys_oneClassifyDescription).then((res) => {
          //   this.bannerList=res.data.data;
          this.clist = res.data.data
        })
      },
      getBuyStauts(oneCategoryId, twoCategoryId) {
        this.$axios.get(this.$common.login_bugTag + '?oneCategoryId=' + oneCategoryId + '&twoCategoryId=' +
          twoCategoryId).then((res) => {
          this.$store.commit('setIsBuy', res.data.data.bugTag);
          window.sessionStorage.isbuy = res.data.data.bugTag;
          bus.$emit('isbuy', res.data.data.bugTag)
          if (this.$route.name == 'homeworklist' || this.$route.name == 'training' || this.$route.name ==
            'highfrequency' || this.$route.name == 'double' || this.$route.name == 'history' || this.$route.name ==
            'examination' || this.$route.name == 'beforeexamination' || this.$route.name == 'errorcollect') {


            if (this.$store.state.isbuy == 0) {
              this.isshow = true;
              this.isShowWrap = false;
            } else {
              this.isshow = false;
              this.isShowWrap = true;
            }

          } else {
            this.isshow = false;
            this.isShowWrap = true;
          }
        })
      }
    },
    created() {
      this.getCustomer();
      this.routerName = this.$route.fullPath;
      this.getList();
      if (this.token) {
        this.getUserInfo()
      }
      if (this.$route.name == 'homeworklist' || this.$route.name == 'training' || this.$route.name == 'highfrequency' ||
        this.$route.name == 'double' || this.$route.name == 'history' || this.$route.name == 'examination' || this
        .$route.name == 'beforeexamination' || this.$route.name == 'errorcollect') {

        console.log(this.$store.state.isbuy + 'this.$store.state.isbuy')
        if (this.$store.state.isbuy == 0) {
          this.isshow = true;
          this.isShowWrap = false
        } else {
          this.isshow = false;
          this.isShowWrap = true;
        }

      } else {
        this.isshow = false;
        this.isShowWrap = true;
      }
      console.log(this.isShowWrap + 'this.isShowWrap')
      console.log(this.isshow + 'this.isshow')
    },
    watch: {
      token(val) {
        if (val) {
          this.getUserInfo()
        }
      },
      '$route'(to, from) {
        // data数据操作
        this.title = window.sessionStorage.title
        this.firstTitle = window.sessionStorage.firstTitle
        this.routerName = to.fullPath;
        if (to.name == 'homeworklist' || to.name == 'training' || to.name == 'highfrequency' || to.name == 'double' ||
          to.name == 'history' || to.name == 'examination' || to.name == 'beforeexamination' || to.name ==
          'errorcollect') {
          if (this.$store.state.isbuy == 0) {
            this.isshow = true;
            this.isShowWrap = false
          } else {
            this.isshow = false;
            this.isShowWrap = true;
          }
        } else {
          this.isshow = false;
          this.isShowWrap = true;
        }

        console.log(this.isshow + 'this.isshow')
        console.log(this.isShowWrap + 'this.isShowWrap')

      }
    },
    mounted() {
      this.title = window.sessionStorage.title;
      this.firstTitle = window.sessionStorage.firstTitle
      bus.$on('login', () => {
        this.showLogin = true;
      })
      bus.$on('checkBuy', (obj) => {
        this.getBuyStauts(obj.parentId, obj.categoryId);
        window.sessionStorage.categoryName = obj.categoryName;
        this.categoryName = obj.categoryName;
      })
    }
  }
</script>

<style scope>
  .childName {
    position: absolute;
    background: #fff;
    z-index: 1988;
    min-width: 175px;
    display: none;
  }

  .childName-bg {
    background-color: #4fa7ff;
    width: 100%;
    height: 3px;
  }

  ul.childName li {
    font-size: 14px;
    line-height: 40px;
    color: #333;
    text-indent: 15px;
    border-bottom: 1px solid #ededed;
    list-style: disc inside;
  }

  ul li {
    list-style: none;
  }

  .navname {
    line-height: 40px;
  }

  .navname:hover {
    color: #4fa7ff;
  }

  ul.childName li:hover {
    color: #4fa7ff;
  }

  .navlist:hover .childName {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue